<template>
  <div>
    <table-actions>
      <router-link to="/plus/new" tag="button">Добавить промокоды</router-link>
      <button @click="downloadExcel">Экспорт в Excel</button>
    </table-actions>
    <table-element v-bind="tableOpt">
      <template #actions="{ row }">
        <button @click="deleteByCode(row.code)">Удалить</button>
      </template>
    </table-element>

    <paginator :model="meta.list_data" @change="changePage" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TableElement from '@/components/common/TableElement';
import TableActions from '@/components/common/TableActions';

export default {
  name: 'all-plus-table',

  components: {
    TableElement,
    TableActions,
  },

  props: {
    tableOptions: Object,
  },

  computed: {
    ...mapGetters({
      meta: 'plus/meta',
    }),

    tableOpt() {
      return {
        ...this.tableOptions,

        columns: [
          { label: 'VIN', name: 'vin', width: '20%' },
          { label: 'Промокод', name: 'code' },
          { label: 'Дата создания', name: 'created_at', width: '20%' },
          { label: 'Дата активации', name: 'activated_at' },
          { label: 'IDP ID', name: 'activated_by_user_id' },
          { label: 'Автор создания', name: 'created_by_user_name' },
        ],

        actions: true,
      };
    },
  },

  methods: {
    ...mapActions({
      export: 'plus/export',
      delete: 'plus/delete',
      fetch: 'plus/fetch',
    }),

    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
      if (type === 'error') {
        this.$snotify.error(msg, null, {
          showProgressBar: false,
        });
      }
    },

    changePage(skip) {
      this.$emit('changePage', skip);
    },

    async downloadExcel() {
      const file = await this.export();

      if (file.data) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(file.data);
        link.download = 'Promocodes.xlsx';
        link.click();
      } else {
        this.toast('Произошла ошибка при загрузке файла.', 'error');
      }
    },

    async deleteByCode(code) {
      if (!confirm(`Действительно удалить промокод "${code}"`)) {
        return
      }

      const err = await this.delete(code);
      if (err) {
        this.toast('Произошла ошибка.', 'error');
        return;
      }

      this.toast('Код успешно удален.', 'success');
      await this.fetch();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
